<template>
  <div v-if="isMounted">
    <section class="section-chechout">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-4">
            <n-button :style="myTheme.customizeButton" type="primary" @click="onAddMoreItems" round block>{{
              $t('button.add_more_items') }}</n-button>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-4">
            <cart-details :action="btnAction" :hide="false" :showTable="true"></cart-details>
          </div>
        </div>
      </div>
    </section>
    <order-changes-confirmation ref="popupConfirmation"></order-changes-confirmation>
    <order-modal ref="itemModal" :fromItem="fromItem" :editMode="editMode" :index="index" :orderType="newCart.orderType">

      <order-item-option v-if="fromItem && fromItem.hasOptions" slot="item-options" :options="fromItem.options" :isDeliverect="newCart.is_deliverect" />
      <order-item-meal-deal-sections slot="item-meal-deal-sections" v-if="fromItem && fromItem.is_meal_deal"
        :order-type="newCart.orderType" :sections="fromItem.sections" :isDeliverect="newCart.is_deliverect"  />
    </order-modal>
  </div>
</template>
<script>
import { Button } from "@/components";
import { CartDetails } from "./components";
import { OrderModal } from "./modals";
import { ACTIONS } from "@/utilities/enums";
import { OrderItemOption, OrderItemMealDealSections } from "@/views/partial";
import { OrderChangesConfirmation } from "@/layout";
import { orderingMixin } from "@/mixins";
import router from "@/router";
export default {
  name: "cart",
  mixins: [orderingMixin],
  components: {
    CartDetails,
    [Button.name]: Button,
    OrderModal,
    OrderChangesConfirmation,
    OrderItemOption,
    OrderItemMealDealSections
  },
  data() {
    return {
      index: -1,
      fromItem: null,
      editMode: false,
      btnAction: ACTIONS.CHECKOUT,
      isMounted: false,
    };
  },
  methods: {
    onAddMoreItems() {
      router.push("/menu");
    }
  },
  created() {
    //---- init the localStorage
    this.addEventListener();
    this.removeEventListner();
    this.openPopUpConfirmationEventListner();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
